import React from "react";
import { APP_DESIGNED, colors } from "./OnboardingBuildAndSubmit";
import { FaCheck } from "react-icons/fa";
import BuildAndSubmitSlideOutButton from "./BuildAndSubmitSlideOut";

const AppDesigned = ({
  getIsCompleted
}) => {

  return (
    <div className="flex flex-row justify-between items-center p-2">
      <div className="w-full flex flex-row justify-start items-center">
        <button
          type="button"
          className={`p-2 cursor-not-allowed border-3 rounded`}
          style={{
            background: getIsCompleted({ id: APP_DESIGNED })
              ? colors.dark
              : "#FFFFFF",
            borderColor: colors.dark,
          }}
        >
          <div
            className="rounded-lg"
            style={{
              borderColor: getIsCompleted({ id: APP_DESIGNED })
                ? colors.dark
                : "#FFFFFF",
              backgroundColor: getIsCompleted({ id: APP_DESIGNED })
                ? colors.dark
                : "#FFFFFF",
            }}
          >
            <FaCheck className={`text-white font-bold rounded-lg h-3 w-3`} />
          </div>
        </button>

        <span className={`line-clamp-2 font-bold ml-2 text-2xl`}>
          {APP_DESIGNED}
        </span>
      </div>

      <BuildAndSubmitSlideOutButton
        type={APP_DESIGNED}
        btnLabel={"ASSETS"}
        title="APP CONFIGURATION"
      />
    </div>
  );
};

export default AppDesigned